import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const CapabilitiesInvoiceStyled = styled.div`
  display: inline-flex;
  flex-direction: column;
  text-wrap: nowrap;
  border-radius: 4px;
  background-color: ${props => props.theme.uiColors.feesBySolutionBackground01};
  min-width: 347px;
  max-height: 509px;
  overflow-y: scroll;
  ${mixins.forceScrollbar}
  
  .capabilitiesInvoice {
    &__title {
      color: ${props => props.theme.uiColors.textBodyDefault};
      font-family: ${props => props.theme.fontSemiBold};
      font-size: 14px;
      padding: 10px 16px;
      border-bottom: solid 1px ${props => props.theme.uiColors.feesBySolutionBorder};
    }
    
    &__solution {
      display: inline-flex;
      background-color: ${props => props.theme.uiColors.feesBySolutionSolutionBackground};
      font-family: ${props => props.theme.fontSemiBold};
      font-size: ${props => props.theme.fontSizeXS};
      justify-content: space-between;
      
      &Item {
        padding: 8px 18px;
        color: ${props => props.theme.uiColors.feesBySolutionItemText};
      }
      
      &Price {
        padding: 8px 32px;
        color: ${props => props.theme.uiColors.feesBySolutionItemPrice};
      }
    }
    
    &__categories {
      padding: 8px 2px;
    }
    
    &__category {
      padding: 7px 16px;
      
      &Title {
        color: ${props => props.theme.uiColors.feesBySolutionItemText};
        font-size: ${props => props.theme.fontSizeXS};
        font-family: ${props => props.theme.fontSemiBold};
      }

      &Container {
        display: flex;
        justify-content: space-between;
        font-family: ${props => props.theme.fontRegular};
        font-size: ${props => props.theme.fontSizeXS};
        border-bottom: solid 1px ${props => props.theme.uiColors.feesBySolutionBorder};
        padding: 8px 14px;

        &Item {
          color: ${props => props.theme.uiColors.textBodyDefault};
          
          &__bold {
            color: ${props => props.theme.uiColors.textBodyDefault};
            font-family: ${props => props.theme.fontBold};
          }

          &__strikethrough {
            color: ${props => props.theme.uiColors.textBodyDefault};
            font-family: ${props => props.theme.fontRegular};
          }
        }

        &Price {
          color: ${props => props.theme.uiColors.feesBySolutionItemPrice};
          font-family: ${props => props.theme.fontSemiBold};

          &__bold {
            color: ${props => props.theme.uiColors.feesBySolutionItemPrice};
            font-family: ${props => props.theme.fontBold};
          }

          &__strikethrough {
            color: ${props => props.theme.uiColors.feesBySolutionItemText};
            text-decoration: line-through;
            font-family: ${props => props.theme.fontRegular};
          }
        }
      }
    }

    &__total {
      display: inline-flex;
      background-color: ${props => props.theme.uiColors.feesBySolutionSolutionBackground};
      justify-content: space-between;
      padding: 8px 16px;

      &Item {
        color: ${props => props.theme.uiColors.feesBySolutionItemText};
        font-size: ${props => props.theme.fontSizeXS};
        font-family: ${props => props.theme.fontSemiBold};
      }

      &Price {
        color: ${props => props.theme.uiColors.feesBySolutionItemPrice};
        font-size: 14px;
        font-family: ${props => props.theme.fontRegular};
      }
    }

    &__paid {
      display: inline-flex;
      background-color: ${props => props.theme.uiColors.feesBySolutionPaidBackground};
      justify-content: space-between;
      padding: 8px 16px;
      font-family: ${props => props.theme.fontSemiBold};
      align-items: center;
      border-radius: 0 4px;

      &Item {
        color: ${props => props.theme.uiColors.textBodyDefault};
        font-size: ${props => props.theme.fontSizeXS};
      }

      &Price {
        color: ${props => props.theme.uiColors.feesBySolutionPaidPrice};
        font-size: 20px;
      }
    }
  }
`;
